import { ListSubheader as MUIListSubheader, styled } from '@mui/material';
import { forwardRef } from 'react';

const CustomListSubheader = styled(MUIListSubheader)(({ theme }) => {
    return {
        padding: theme.spacing(1, 0),
    };
});

const ListSubheader = forwardRef((props, ref) => {
    return <CustomListSubheader ref={ref} {...props} />;
});

export default ListSubheader;
